import { createContext, useEffect, useMemo, useState } from "react";
import { useWeb3React } from "@web3-react/core";

import { injected, walletConnect } from "./connectors";

import ErrorModal from "../../components/errorModal";

export const W3Context = createContext({
  active: false,
  account: "",
  library: null,
  connector: null,
});

export const W3Provider = ({ children }) => {
  const { active, account, library, connector, activate, deactivate } =
    useWeb3React();

  const [hasNetworkChanged, setNetworkChanged] = useState(false);
  const [hasWeb3ReactUpdate, setWeb3ReactUpdate] = useState(false);

  const [displayErrorModal, setDisplayErrorModal] = useState(false);
  const [titleErrorMessage, setTitleErrorMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const connectInjected = async () => {
    try {
      if (
        typeof window.ethereum !== "undefined" &&
        window.ethereum.isConnected() &&
        !active
      ) {
        checkNetwork();
      }
      await activate(injected);
    } catch (ex) {
      console.log(ex);
    }
  };

  const connectWalletConnect = async () => {
    try {
      if (
        typeof window.ethereum !== "undefined" &&
        window.ethereum.isConnected() &&
        !active
      ) {
        checkNetwork();
      }
      await activate(walletConnect);
    } catch (ex) {
      console.log(ex);
    }
  };

  const disconnect = async () => {
    try {
      deactivate();
    } catch (ex) {
      console.log(ex);
    }
  };

  const addListeners = () => {
    if (typeof window.ethereum !== "undefined" && !hasNetworkChanged) {
      window.ethereum.on("networkChanged", (networkId) => {
        setDisplayErrorModal(false);
        setNetworkChanged(true);

        checkNetwork();
      });
    }

    if (typeof connector !== "undefined" && !hasWeb3ReactUpdate) {
      connector.on("Web3ReactUpdate", (_update) => {
        setDisplayErrorModal(false);
        setWeb3ReactUpdate(true);

        checkNetwork();
      });
    }
  };

  const showErrorModal = () => {
    setErrorMessage(
      "You are on the wrong network, please switch to Polygon network"
    );
    setTitleErrorMessage("Wrong network");
    setDisplayErrorModal(true);
  };

  const checkNetwork = () => {
    setDisplayErrorModal(false);

    if (
      typeof window.ethereum !== "undefined" &&
      window.ethereum.chainId !== null &&
      window.ethereum.chainId !== "0x89"
    ) {
      showErrorModal();
    }
  };

  const W3CValue = useMemo(
    () => ({
      active,
      account,
      library,
      connector,
      connectInjected,
      connectWalletConnect,
      disconnect,
      checkNetwork,
    }),
    [active, account, library, connector, activate, deactivate]
  );

  useEffect(() => {
    addListeners();

    injected.isAuthorized().then((isAuth) => {
      if (isAuth && !active) {
        connectInjected();
      }
    });
  }, []);

  return (
    <W3Context.Provider value={W3CValue}>
      <ErrorModal
        title={titleErrorMessage}
        message={errorMessage}
        displayModal={displayErrorModal}
        setDisplayModal={setDisplayErrorModal}
      />
      {children}
    </W3Context.Provider>
  );
};
